/**
 * Escape untrusted text to prevent XSS when interpolating into HTML.
 * Uses DOM-based escaping which handles all HTML entities automatically.
 */
export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
